<div class="d-flex justify-content-center py-3">
  <div class="card border-1" style="max-width: 700px; width: 100%;">
    <div class="card-body">
      <!-- Textarea -->
      <textarea class="form-control  border rounded-5" [rows]="data.textarea.rows" 
        placeholder="{{ data.textarea.placeholder }}" (click)="openModal('Textarea')"></textarea>

      <!-- File Upload Buttons -->
      <div class="d-flex flex-wrap gap-2 mt-3 justify-content-center flex-nowrap">
        <button *ngFor="let button of data.buttons" 
                style="font-weight: bold;"
                class="btn btn-sm d-flex align-items-center gap-1 mx-3"
                (click)="openModal(button.label)">
          <i [class]="button.icon"></i> {{ button.label }}
        </button>
      </div>      
    </div>
  </div>
</div>
